export interface ActingGig {
  name: string;
  year: string;
  role: string;
  category: string;
  thumbnail?: string;
  imdb?: string;
  youtube?: string;
  description?: string;
  images?: string[];
  folder?: string;
}

export const actingGigs: ActingGig[] = [
  {
    name: "San Gabriel Valley",
    year: "2017",
    role: "Orlando",
    category: "Series",
    thumbnail: "/acting/San Gabriel Valley/Untitled.png",
    imdb: "https://www.facebook.com/SanGabrielValley.Show/",
    youtube: "https://www.youtube.com/watch?v=OEHkBBLq6BA&list=PL81CXxlZvjGQ-x_nyE_m2JxE-b6T3r4R9&index=6",
    images: ["/acting/San Gabriel Valley/Untitled.png"],
    folder: "San Gabriel Valley"
  },
  {
    name: "I Love You I Hate You I Love You",
    year: "2016",
    role: "Walt",
    category: "Short",
    thumbnail: "/acting/I Love You I Hate You I Love You/Untitled.png",
    imdb: "https://www.imdb.com/title/tt4326784/?ref_=nm_ov_bio_lk",
    images: ["/acting/I Love You I Hate You I Love You/Untitled.png"],
    folder: "I Love You I Hate You I Love You"
  },
  {
    name: "Bleeding Edge",
    year: "2016",
    role: "Data Center Tech",
    category: "Film",
    thumbnail: "/acting/Bleeding Edge/Untitled 1.png",
    imdb: "https://www.imdb.com/title/tt3633032/characters/nm6562946?ref_=ttfc_fc_cl_t23",
    youtube: "https://youtu.be/B_YHHX0NYFQ",
    description: "This was my first and one my best roles as an actor where I played the front desk data security technician. Even though the voice is not mine, I had to learn my lines and having it been my first performance in front of a camera, it was unnoticed in my cameo.",
    images: [
      "/acting/Bleeding Edge/Untitled 1.png",
      "/acting/Bleeding Edge/Untitled 2.png",
      "/acting/Bleeding Edge/Untitled.png"
    ],
    folder: "Bleeding Edge"
  },
  {
    name: "Why Not",
    year: "2015",
    role: "Dave",
    category: "Short",
    thumbnail: "/acting/Why Not/Screenshot_2024-01-28_at_1.43.44_PM.png",
    youtube: "https://vimeo.com/124646981",
    images: [
      "/acting/Why Not/Screenshot_2024-01-28_at_1.43.44_PM.png",
      "/acting/Why Not/Screenshot_2024-01-28_at_1.44.12_PM.png",
      "/acting/Why Not/Screenshot_2024-01-28_at_1.45.05_PM.png",
      "/acting/Why Not/Screenshot_2024-01-28_at_1.45.14_PM.png",
      "/acting/Why Not/Screenshot_2024-01-28_at_1.46.06_PM.png"
    ],
    folder: "Why Not"
  },
  {
    name: "The Judgement",
    year: "2015",
    role: "Trevor",
    category: "Short",
    thumbnail: "/acting/The Judgement/Untitled.png",
    youtube: "https://youtu.be/TdmZ-kGHV1M",
    images: ["/acting/The Judgement/Untitled.png"],
    folder: "The Judgement"
  },
  {
    name: "Marker!",
    year: "2015",
    role: "James",
    category: "Short",
    thumbnail: "/acting/Marker!/Untitled.png",
    youtube: "https://youtu.be/GTY18SNsxJY",
    images: ["/acting/Marker!/Untitled.png"],
    folder: "Marker!"
  },
  {
    name: "Mr. MVNC 2015 Pageant",
    year: "2015",
    role: "",
    category: "Pageant",
    thumbnail: "/acting/Mvnc/thumb.png",
    description: "Participated in the Mr. MVNC 2015 Pageant."
  },
  {
    name: "Gone to Ground",
    year: "2015",
    role: "Thief",
    category: "Short",
    imdb: "https://www.imdb.com/title/tt4834668/?ref_=nm_ov_bio_lk"
  },
  {
    name: "Mr. Vancouver Winner",
    year: "2014",
    role: "",
    category: "Pageant",
    thumbnail: "/acting/MrVan/image.png",
    description: "Winner of Mr. Vancouver 2014."
  },
  {
    name: "The Lab",
    year: "2014",
    role: "Steven Lee",
    category: "Series",
    thumbnail: "/acting/The Lab/Screenshot_2024-01-28_at_1.21.29_PM.png",
    youtube: "https://www.youtube.com/@watchTheLab",
    images: [
      "/acting/The Lab/Screenshot_2024-01-28_at_1.21.29_PM.png",
      "/acting/The Lab/Screenshot_2024-01-28_at_1.22.56_PM.png",
      "/acting/The Lab/Screenshot_2024-01-28_at_1.25.33_PM.png",
      "/acting/The Lab/Screenshot_2024-01-28_at_1.26.35_PM.png",
      "/acting/The Lab/Screenshot_2024-01-28_at_1.28.51_PM.png"
    ],
    folder: "The Lab"
  },
  {
    name: "The Phone Calls",
    year: "2014",
    role: "Frankie",
    category: "Short",
    thumbnail: "/acting/The Phone Calls/Untitled.png",
    youtube: "https://youtu.be/NhCzTV9mVi4",
    images: ["/acting/The Phone Calls/Untitled.png"],
    folder: "The Phone Calls"
  },
  {
    name: "Have Fun Tonight",
    year: "2017",
    role: "Wei Yu",
    category: "Short",
    thumbnail: "/acting/HaveFun/image.png",
    youtube: "https://www.youtube.com/watch?v=BOv1xhiPNAE"
  },
  {
    name: "The Interview",
    year: "2018",
    role: "Mark Tsang",
    category: "Short",
    thumbnail: "/acting/The Interview/Untitled.png",
    youtube: "https://youtu.be/ZyAIkxClEFI",
    images: ["/acting/The Interview/Untitled.png"],
    folder: "The Interview"
  },
  {
    name: "Veda",
    year: "2017",
    role: "",
    category: "Short",
    thumbnail: "/acting/Veda/Untitled.png",
    youtube: "https://www.youtube.com/watch?v=LvpKgHbserU",
    images: ["/acting/Veda/Untitled.png"],
    folder: "Veda"
  },
  {
    name: "Wish Weaver",
    year: "2015",
    role: "",
    category: "Short",
    thumbnail: "/acting/Wish Weaver/Untitled.png",
    youtube: "https://youtu.be/LuACBuddpzc?si=kbfxvw8-hHXcv3YX",
    images: ["/acting/Wish Weaver/Untitled.png"],
    folder: "Wish Weaver"
  },
  {
    name: "Superstitions",
    year: "2015",
    role: "Bartender",
    category: "Short",
    thumbnail: "/acting/Superstitions/Untitled 1.png",
    youtube: "https://youtu.be/VDPtqiXCu_Q",
    images: [
      "/acting/Superstitions/Untitled 1.png",
      "/acting/Superstitions/Untitled.png"
    ],
    folder: "Superstitions"
  },
  {
    name: "Remembrance",
    year: "2015",
    role: "Brayden",
    category: "Short",
    thumbnail: "/acting/Remembrance/Untitled 1.png",
    youtube: "https://youtu.be/DWEddhxeAvc",
    images: [
      "/acting/Remembrance/Untitled 1.png",
      "/acting/Remembrance/Untitled 2.png",
      "/acting/Remembrance/Untitled.png"
    ],
    folder: "Remembrance"
  }
];
